import { useMediaQuery, breakpoints } from '@themenu/design-system'

export const useIsSmallMobile = (): boolean => useMediaQuery(breakpoints.down(445))
